<div class="">
  <div class="tabs tabBlue">
    <span class="tablinks bold" onclick="opentab(event, 'page')" id="defaultOpen">Page</span>  
  </div>
</div>
<div class="pageContainer tabcontent pageList" id="page" style="display:block;">   
  <!-- <div class="listing"   
    pageId="pages"
    allApi="all_pages" 
    searchApi="all_pages"
    [showPagination]="true"
    metaApi="pages_meta" 
    search_label="Search Pages..."
    ></div> -->
    <app-all-page-listing></app-all-page-listing>
</div>